import { Door, DoorHardware, HARDWARE_FIELD_NAMES, HardwareFieldName, HardwareGroup } from '@models/doors';
import { Company, FieldHeader } from '@models/companies';
import { normalizeCompanyId } from './company-id';

const GROUPING_EXCLUDED_FIELDS: HardwareFieldName[] = ['H35'];

const GROUPABLE_HARDWARE_FIELD_NAMES = HARDWARE_FIELD_NAMES.filter((fieldName) => !GROUPING_EXCLUDED_FIELDS.includes(fieldName));

function isChecklistAssigned(checklistId: string | undefined): boolean {
  return !!checklistId && checklistId !== '0';
}

function pushUnique(values: string[], value: string | undefined): void {
  if (value && !values.includes(value)) {
    values.push(value);
  }
}

function getHeaderFor(fieldName: string, headers: FieldHeader[]): string {
  return headers.find((header) => header.FieldName === `${fieldName}.Content`)?.Header ?? fieldName;
}

export function groupHardwareForDoors(doors: Door[], headers: FieldHeader[], companies: Company[]): HardwareGroup[] {
  const groups = new Map<string, HardwareGroup>();
  const companyNameById = new Map<string, string>(companies.map((c) => [c.Id, c.Name]));

  for (const door of doors) {
    for (const fieldName of GROUPABLE_HARDWARE_FIELD_NAMES) {
      const hardware: DoorHardware | null | undefined = door[fieldName];
      if (!hardware || !hardware.Content || hardware.Mounted !== false) {
        continue;
      }

      const key = `${fieldName}___${hardware.Content}`;
      let group = groups.get(key);
      if (!group) {
        group = {
          FieldName: fieldName,
          Header: getHeaderFor(fieldName, headers),
          Content: hardware.Content,
          TotalQty: 0,
          DoorIds: [],
          CompanyIds: [],
          CompanyNames: [],
          ChecklistIds: []
        };
        groups.set(key, group);
      }

      const companyId = normalizeCompanyId(hardware.CompanyId);
      group.TotalQty += Number(hardware.Qty) * Number(door.DoorQty);
      pushUnique(group.DoorIds, door.Id);
      pushUnique(group.CompanyIds, companyId);
      pushUnique(group.CompanyNames, companyId ? companyNameById.get(companyId) : undefined);
      pushUnique(group.ChecklistIds, isChecklistAssigned(hardware.ChecklistId) ? hardware.ChecklistId : undefined);
    }
  }

  return [...groups.values()].sort((a, b) => a.Header.localeCompare(b.Header) || a.Content.localeCompare(b.Content));
}
